import React, { useEffect, useRef } from 'react';

import { TOTAL_LENGTH_OF_LONG_LIST } from './constants';
import { generateLongList } from './helpers';
import styles from './index.module.scss';

type HourAndMinuteSelectorProps = {
  remindTimeHour: number;
  remindTimeMinute: number;
  updateRemindTime: (type: 'hour' | 'minute', value: number) => void;
};

const LONG_HOURS_LIST = generateLongList({ isHour: true });
const LONG_MINUTES_LIST = generateLongList({ isHour: false });

const HourAndMinuteSelector = ({
  remindTimeHour,
  remindTimeMinute,
  updateRemindTime,
}: HourAndMinuteSelectorProps) => {
  const hourListRef = useRef<HTMLUListElement | null>(null);
  const minuteListRef = useRef<HTMLUListElement | null>(null);

  useEffect(() => {
    const scrollRemindTimeIntoView = () => {
      const hourList = hourListRef.current;
      const minuteList = minuteListRef.current;
      const halfLengthOfList = (TOTAL_LENGTH_OF_LONG_LIST - 1) / 2;
      if (hourList && remindTimeHour !== undefined) {
        const selectedHour =
          hourList.children[remindTimeHour + 24 * halfLengthOfList];
        if (selectedHour) {
          selectedHour.scrollIntoView();
        }
      }
      if (minuteList && remindTimeMinute !== undefined) {
        const selectedMinute =
          minuteList.children[remindTimeMinute + 60 * halfLengthOfList];
        if (selectedMinute) {
          selectedMinute.scrollIntoView();
        }
      }
    };

    scrollRemindTimeIntoView();
  }, []); // no need any dependencies

  return (
    <div className={styles.remindTimeContainer}>
      <div className={styles.timeSelectorContainer}>
        <p>時</p>
        <ul ref={hourListRef}>
          {LONG_HOURS_LIST.map((hour, index) => {
            return (
              <li
                key={index}
                className={
                  remindTimeHour === index % 24
                    ? styles['hour-selected']
                    : undefined
                }
                onClick={() => updateRemindTime('hour', index % 24)}
              >
                {hour.toString().padStart(2, '0')}
              </li>
            );
          })}
        </ul>
      </div>
      <div className={styles.divider} />
      <div className={styles.timeSelectorContainer}>
        <p>分</p>
        <ul ref={minuteListRef}>
          {LONG_MINUTES_LIST.map((minute, index) => {
            return (
              <li
                key={index}
                className={
                  remindTimeMinute === index % 60
                    ? styles['minute-selected']
                    : undefined
                }
                onClick={() => updateRemindTime('minute', index % 60)}
              >
                {minute.toString().padStart(2, '0')}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default HourAndMinuteSelector;
